<template>
  <v-container grid-list-md fluid>
      <v-layout row >
        <v-flex md12>
          <v-card>
            <v-toolbar dense primary-title>
              <v-toolbar-title>{{$t('view.reporteAuditoria.filtros.label')}}</v-toolbar-title> 
              <v-spacer></v-spacer>
              <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
                <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
              </v-btn>                
            </v-toolbar>
            <v-slide-y-transition>
              <v-card-text v-show="view.elem.showForm">
                <v-layout row>
                  <v-flex md12>
                    <v-form role="form">
                      <!-- Skeleton loader -->
                      <div  v-if="view.action.submit.busy">
                        <vue-content-loading :width="450" :height="158">
                          <rect x="0" y="0" rx="4" ry="4" width="53" height="10" />
                          <rect x="0" y="15" rx="4" ry="4" width="442" height="34" />
                          <rect x="0" y="64" rx="4" ry="4" width="53" height="10" />
                          <rect x="0" y="79" rx="4" ry="4" width="442" height="34" />
                          <rect x="0" y="128" rx="10" ry="10" width="80" height="30" />
                        </vue-content-loading>
                      </div>
                      <v-layout row>
                        <v-flex md6>
                          <div v-if="!view.action.submit.busy">
                            <v-combobox 
                                v-model="$v.reporteAuditoria.usuario.$model"
                                :items="view.elem.select.usuario.options"
                                :label="$t('view.reporteAuditoria.usuario.label')"
                                :error-messages="$t(`validator.${getFirstError($v.reporteAuditoria.usuario)}.text`,'')"
                                item-text="name"
                                item-value="code"
                                :max-height="200" 
                                multiple    
                                dense  
                                :no-data-text= "$t('view.global.common.no-data-text')"                        
                                clearable
                                deletable-chips
                                small-chips>
                            </v-combobox>                            
                          </div>
                        </v-flex>
                        <v-flex md6>
                          <div v-if="!view.action.submit.busy">
                            <v-combobox 
                              v-model="$v.reporteAuditoria.modulo.$model"
                              :items="view.elem.select.modulo.options"
                              :label="$t('view.reporteAuditoria.modulo.label')"
                              :error-messages="$t(`validator.${getFirstError($v.reporteAuditoria.modulo)}.text`,'')"
                              item-text="name"
                              item-value="code"
                              :max-height="200"   
                              dense       
                              :no-data-text= "$t('view.global.common.no-data-text')"                   
                              clearable
                              deletable-chips
                              small-chips>
                            </v-combobox>                            
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex md4>
                          <div v-if="!view.action.submit.busy" >
                            <v-dialog
                              ref="dialogInicio"
                              v-model="modalFechaInicio"
                              :return-value.sync="$v.reporteAuditoria.fecha_inicio.$model"
                              persistent
                              lazy
                              full-width
                              width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="formatFechaInicio"
                                :error-messages = "$t(`validator.${getFirstError($v.reporteAuditoria.fecha_inicio)}.text`,'')"
                                :label="$t('view.reporteAuditoria.fecha_inicio.label')"
                                prepend-icon="event"
                                readonly>
                              </v-text-field>
                              <v-date-picker 
                              :max="$v.reporteAuditoria.fecha_fin.$model"
                              locale="locale" v-model="$v.reporteAuditoria.fecha_inicio.$model" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="modalFechaInicio = false">{{$t('view.global.common.cancel')}}</v-btn>
                                <v-btn flat color="primary" @click="$refs.dialogInicio.save($v.reporteAuditoria.fecha_inicio.$model)">{{$t('view.global.common.ok')}}</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </div>
                        </v-flex>
                        <v-flex md4>
                          <div v-if="!view.action.submit.busy" >
                            <v-dialog
                              ref="dialogFin"
                              v-model="modalFechaFin"
                              :return-value.sync="$v.reporteAuditoria.fecha_fin.$model"
                              persistent
                              lazy
                              full-width
                              width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="formatFechaFin"
                                :error-messages = "$t(`validator.${getFirstError($v.reporteAuditoria.fecha_fin)}.text`,'')"
                                :label="$t('view.reporteAuditoria.fecha_fin.label')"
                                prepend-icon="event"
                                readonly>
                              </v-text-field>
                              <v-date-picker 
                              :min="$v.reporteAuditoria.fecha_inicio.$model"
                              :locale="locale" v-model="$v.reporteAuditoria.fecha_fin.$model" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="modalFechaFin = false">{{$t('view.global.common.cancel')}}</v-btn>
                                <v-btn flat color="primary" @click="$refs.dialogFin.save($v.reporteAuditoria.fecha_fin.$model)">{{$t('view.global.common.ok')}}</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </div>
                        </v-flex>
                        <v-flex md2 right>
                          <v-layout row>
                            <v-flex md12 sm12 xs12 class="col-md-12 col-sm-12 col-xs-12">
                              <div class="pull-right">
                                <v-btn 
                                  @click="getDataAuditoria()" 
                                  :disabled="state.isDisableButtonSubmit()"
                                  color="primary"  dark
                                  icon small>
                                  <v-icon small>search</v-icon>
                                </v-btn>
                                <!-- <button type="button" 
                                    class="btn btn-outline btn-circle btn-primary" 
                                    title="Buscar"
                                    :disabled="state.isDisableButtonSubmit()"
                                    @click="getDataAuditoria()">
                                    <i class="fa fa-search"></i>
                                </button> -->

                                <v-btn 
                                  @click="getExcelAuditoria()" 
                                  :disabled="state.isDisableButtonSubmit()"
                                  color="primary"  dark
                                  icon small>
                                  <v-icon small>mdi-file-excel</v-icon>
                                </v-btn>

                                <!-- <button type="button" 
                                    title="Exportar Excel"
                                    class="btn btn-outline btn-circle btn-primary" 
                                    :disabled="state.isDisableButtonSubmit()"
                                    @click="getExcelAuditoria()">
                                    <i class="fa fa-file-excel-o"></i>
                                </button> -->
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-slide-y-transition>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md12>
          <v-card>
            <v-toolbar dense primary-title>
              <v-toolbar-title>{{$t('view.bitacora.registros.label')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="view.elem.showTable = !view.elem.showTable">
                <v-icon>{{ view.elem.showTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
              </v-btn>
            </v-toolbar>
            <v-slide-y-transition>
              <v-card-text v-show="view.elem.showTable">
                <v-layout row>
                  <v-flex md12>
                    <div class="table-responsive">
                      <table id="reporteAuditoriaTable" class="table table-striped table-bordered table-hover responsive nowrap"  style="width:100%">
                        <thead>
                          <tr>
                            <th class="all">Módulo</th>
                            <th class="all">Revisión</th>
                            <th class="all">Usuario</th>
                            <th class="all">Fecha y hora</th>
                            <th class="all">Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                        </tbody>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-slide-y-transition>
          </v-card>
        </v-flex>
      </v-layout>
      <auditoria ref="auditModal"></auditoria>
  </v-container>
</template>
<script>
import {ReporteAuditoriaModel} from "@/models/bitacoras/reporte-auditoria";
import ReporteAuditoriaAPI from "@/services/bitacoras/auditoria";
import CombosAPI from "@/services/catalogos";
import {required} from "vuelidate/lib/validators";
import {minDateFrom, maxDateFrom} from "@/helpers/vuelidate/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import VueContentLoading from 'vue-content-loading';
import Auditoria from "@/components/auditoria/Auditoria";
// import DataTable from "@/views/reporteAuditoria/DataTable";
import Multiselect from 'vue-multiselect';
import tippy from 'tippy.js';
import * as states from "@/views/bitacoras/reporteAuditoria/reporte-auditoria-states";
import * as R from "ramda";
import * as dateMethods from "@/helpers/date-methods";
//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
  }
};
let select = {
  usuario:{
    options:[{name:'Administrador', code:'administrador'}]
  }
  ,  usuarioAll:{
    options:[]
  }
  ,  modulo:{
    options:[{name:'Usuarios',code:'Users'}]
  }  
}
//Action's state
const action = {
  submit:{
    busy:false
  }
};

//Initial Model
//const reporteAuditoria = new ReporteAuditoriaModel();
//Helpers
function evaluateModelChangedMethodResult(data){
  if(!data && typeof data === "boolean"){
  return data
  }

  if(data && typeof data === "object"){
  return data.length>=1;
  } 
}
const modelIsModified = R.curry((model)=>R.compose(evaluateModelChangedFlag,model.changed));

export default {
  name: "ReporteAuditorias",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    let _locale = this.$store.language;
    return {
      locale: _locale
      , date: undefined
      , modalFechaInicio : false
      , modalFechaFin : false
      , reporteAuditoria : undefined
      , registrosAuditoria:[]
      , selectedModulo: undefined
      , selectedUser: undefined
      , dataTable: undefined
      , auditoria:{
        clave: ''
        , tabla:''
        , descripcion:''
      }
      , state : new Object()
      , view:{
        title:"Reportes Auditorias"
        , action
        , elem:{
          button
          , select
          , showForm:true
          , showTable: true
        }
      }
      , check:true
    };
  }
  ,methods: {
    ...allValidatorMethods
    , async submit(){
      try{
        this.$refs.tableReporteAuditoria._fnReDraw();
      }catch(error){
        console.log('error');
      }
    }
    , addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    }
    , getLimitText(){
      return count=> ` y  ${count} más `;
    }
    , emitEventAuditRow(event){
      const {audit,dataDescripcion, tabla, rev} = event.currentTarget;
      this.$refs.auditModal.loadAuditMainDetail({clave:audit,tabla:tabla,descripcion:dataDescripcion,revision:rev});
      document.getElementById('audit_descripcion_div').style.display= 'none';

    }
    , newAuditButton(id,dataDescripcion, modulo, rev, eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("data-toggle","tooltip");
      button.setAttribute("data-placement","top");
      button.setAttribute("title","Auditoría");
      button.classList.add('button', 'button--sacnite', 'button--round-l', 'custom');
      button.audit = id || "";
      button.dataDescripcion = dataDescripcion || '';
      button.tabla = modulo || '';
      button.rev = rev || 0;
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-search');
      //label settings
      label.appendChild(document.createTextNode('audit'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    }
    , formatDate( date, params ) {
      var options = {
          year: "numeric"
          , month: "2-digit"
          , day: "2-digit"
          , hour:"2-digit"
          , minute:"2-digit"
          , second:"2-digit"
      };

      if( params ) {
          options = Object.assign( options, params );
      }
      return new Date( date ).toLocaleString( 'es-MX', options );
    }
    
    , async getExcelAuditoria(){
      if(!this.state.submit(this.reporteAuditoria)){
        return;
      }
      this.view.action.submit.busy = true;
      let fecha = '('+this.reporteAuditoria.fecha_inicio+'|'+this.reporteAuditoria.fecha_fin+')';
      let usuario = '';
      let modulo = '';

      if(this.reporteAuditoria.usuario != null && this.reporteAuditoria.usuario.length > 0){
        let usuarioValue = this.reporteAuditoria.usuario.map(({code}) => code).toString();
        usuario = usuarioValue;
      }
      
      let moduloValue = this.reporteAuditoria.modulo.code;          
      modulo = this.reporteAuditoria.modulo.code;
      
      let response = await ReporteAuditoriaAPI.reporteExcel({usuario:usuario, modulo:modulo, fecha:fecha});
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.headers.filename); //or any other extension
      document.body.appendChild(link);
      link.click();
      this.view.action.submit.busy = false;
    }
    , async getDataAuditoria(){
      try
      {
        if(!this.state.submit(this.reporteAuditoria)){
          return;
        }

        let response;
        let fecha = '('+this.reporteAuditoria.fecha_inicio+'|'+this.reporteAuditoria.fecha_fin+')';
        let usuario = '';
        let modulo = '';

        if(this.reporteAuditoria.usuario != null && this.reporteAuditoria.usuario.length > 0){
          let usuarioValue = this.reporteAuditoria.usuario.map(({code}) => code).toString();
          usuario = usuarioValue;
        }

        let moduloValue = this.reporteAuditoria.modulo.code;          
        modulo = this.reporteAuditoria.modulo.code;
        

        response = await ReporteAuditoriaAPI.reporte({usuario:usuario, modulo:modulo, fecha:fecha});
        if(response.status==200 &&  response.data.meta.code && response.data.meta.code=="OK")
        {
          try
          { 
            const vm = this;
      
            try { window.$('#reporteAuditoriaTable').dataTable().fnDestroy();}catch(error){}
            
            let auditTBody = document.getElementById('reporteAuditoriaTable').getElementsByTagName('tbody')[0];
            auditTBody.innerHTML='';

            const {data:{results:{reporte:data}}}= response;
            const {data:{results:{modulo:moduloValue}}}= response;
            const {data:{results:{usuario:usuarioValue}}}= response;

            data.forEach(function(item,index) { 
              // Insert a row in the table at the last row
              var length = auditTBody.rows.length;
              var newRow   = auditTBody.insertRow(length);

              newRow.insertCell(0).append(document.createTextNode(moduloValue));
              newRow.insertCell(1).append(document.createTextNode(item.REV));
              newRow.insertCell(2).append(document.createTextNode(item.usuariomodificacion));
              newRow.insertCell(3).append(document.createTextNode(vm.formatDate(item.fechamodificacion)));
              newRow.insertCell(4).append(vm.newAuditButton(item.clave, item.usuariomodificacion, modulo, item.REV,vm.emitEventAuditRow));
              newRow.cells[4].setAttribute('class','text-center');
            }); 

            window.$('#reporteAuditoriaTable').dataTable({
            "responsive": true
            , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
            ,  "order": [[ 0, "desc" ]]
            , "columnDefs": [
              { "orderable": false, "targets": 4 , "className":"text-center"}
            ]
           });         

          } catch(err){
            console.log(err)
          }
        }
      }
      catch(error){
        console.log(error)
      }
    }
  }
  , computed:{
    formatFechaInicio(){
      return dateMethods.formatDate(this.$v.reporteAuditoria.fecha_inicio.$model);
    }
    ,formatFechaFin(){
      return dateMethods.formatDate(this.$v.reporteAuditoria.fecha_fin.$model);
    }
  }
  , validations:{
    reporteAuditoria:{
      usuario:{
        required
      }
      , modulo:{
        required
      }
      , fecha_inicio:{
        required
        , maxDateFrom: maxDateFrom('fecha_fin')
      }
      , fecha_fin:{
        required
        , minDateFrom : minDateFrom('fecha_inicio') 
      }
    }
  }
  , components: {
    VueContentLoading
    , Auditoria
    , Multiselect
  }
  // Instance Lifecycle Hooks
  , async created()
  {
    Object.setPrototypeOf(this.state, new states.InitialState(this));
    try{
      
      const responseCombosUsuariosActive = await CombosAPI.get({tipo:'usuariosActive'});
      select.usuario.options = responseCombosUsuariosActive.data.results.combo;
      const responseCombosUsuariosAll = await CombosAPI.get({tipo:'usuarios'});
      select.usuarioAll.options = responseCombosUsuariosAll.data.results.combo;
      const responseComboModulos = await CombosAPI.get({tipo:'modulos'});
      select.modulo.options = responseComboModulos.data.results.combo;
    } catch(error){

    }
    Object.setPrototypeOf(this.state, new states.EditingState(this,this.reporteAuditoria));
  }
  , beforeMount(){
  }
  , mounted(){
    this.$v.$reset();
    // this.$parent.appJQueryConfigMethod();
    this.$nextTick(function(){
        this.dataTable =   window.$('#reporteAuditoriaTable').dataTable({
          "responsive": true
          , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
          ,  "order": [[ 0, "desc" ]]
          , "columnDefs": [
              { "orderable": false, "targets": 4 , "className":"text-center"}
            ]
        })
    });
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bitacoras/reporteAuditoria/ReporteAuditoria.vue